import React from "react";
import { Board } from "../Board/Board";
import "./Game.css";

export class Game extends React.Component {
	render() {
		return (
			<div>
				<Board />
				<div className="game-info">
					<div>{/* status */}</div>
					<ol>{/* TODO */}</ol>
				</div>
			</div>
		);
	}
}
